<template>
  <div>
    <div style="height: 40px;padding-top: 20px;margin: 0 20px">
      <el-date-picker v-fixZoom size="small" :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button size="small" type="success" @click="searchBtn">查询</el-button>
    </div>
    <div style="margin: 0 20px">
      <el-card class="box-card my-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 16px;color: #999999">个人月度充值消费统计</span>
        </div>
        <div style="height: 20px">
          <el-row>
            <el-col :span="6">
              <span>月份：</span><span style="font-size: 24px;color: #E6A23C">{{ elderlyFinanceMonth.month }}</span>
            </el-col>
            <el-col :span="9">
              <span>当月充值总额：</span><span style="font-size: 24px;color: #67C23A">{{ elderlyFinanceMonth.recharge_amount}}</span>
            </el-col>
            <el-col :span="9">
              <span style="font-size: 24px;color: #409EFF">{{ elderlyFinanceMonth.consumption_amount }}</span>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div style="max-height: 350px;margin: 20px;overflow-y: auto">
      <el-table size="mini" :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="elderly_name"
          label="老人姓名"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="变动类型"
          width="90"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.change_type === 1">充值</span>
            <span v-if="scope.row.change_type === 2">消费</span>
            <span v-if="scope.row.change_type === 3">退款</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="change_amount"
          label="变动金额"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="before_amount"
          label="变动前余额"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="after_amount"
          label="变动后余额"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="change_time"
          label="变动时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="change_remark"
          label="变动备注"
          min-width="100"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryelderlyfinancebill, queryelderlyfinanceorder} from '../../../api/yanglaoyuan'

export default {
  name: 'accountDetail',
  props: {
    detailObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      elderlyFinanceMonth: {
        month: '',
        recharge_amount: '',
        consumption_amount: ''
      }
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    // Date.prototype.format = this.validate.format
    // let end = new Date().format('yyyy-MM-dd')
    // const start = this.commonType.GetDateStr(-7)
    // this.sendDate = [start.format('yyyy-MM-dd'), end]

    const end = new Date()
    const start = new Date()
    start.setDate(1)
    this.sendDate = [start.format('yyyy-MM-dd'), end.format('yyyy-MM-dd')]
    this.getTimeObj()
    this.checkData()
    this.queryDataTable()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    },
    searchBtn () {
      this.checkData()
      this.queryDataTable()
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.detailObj.row.eid,
        epid: this.detailObj.row.epid,
        ep_name: '',
        change_time_from: this.sendDate[0] + ' 00:00:00',
        change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinanceorder(params, data).then(res => {
        this.tableData = res.data.elderlyFinanceOrder
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    checkData () {
      let data = {
        eid: this.detailObj.row.eid,
        epid: this.detailObj.row.epid,
        change_time_from: this.sendDate[0] + ' 00:00:00',
        change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinancebill(data).then(res => {
        this.elderlyFinanceMonth = res.data.elderlyFinanceMonth
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/accountDetail.vue